var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-200 h-full"},[_c('div',{staticClass:"h-screen"},[_c('picker')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }